/**
 * @fileoverview WIP POP-beacon mixins
 *
 * Should eventually create the root of all pop-beacon-*
 * @rally https://rally1.rallydev.com/#/?detail=/userstory/816362881827&fdp=true
 */

import { LitElement } from 'lit';

import { PopBaseMixin } from '../pop-base/mixin.js';
import type { Constructor } from '../pop-base/types';
import { BeaconBaseInterface } from './types';

/**
 * Allows extending a Beacon component generally
 */
export const BeaconBaseMixin = <T extends Constructor<BeaconBaseInterface>>(
  superClass: T,
): T & Constructor<BeaconBaseInterface> => {
  class BeaconBase extends superClass {}
  return BeaconBase;
};

export const BeaconPopMixin = <
  T extends Constructor<BeaconBaseInterface & LitElement>,
>(
  beaconComponent: T,
): T & Constructor<BeaconBaseInterface> => {
  return PopBaseMixin(BeaconBaseMixin(beaconComponent));
};
